const rules = [
  // 子龙
  {
    alias: [
      'mijia.watch.band01in',
      'mijia.watch.band01hktw',
      'mijia.watch.band01dist',
      'mijia.watch.band01ee',
      'mijia.watch.band01me'
    ],
    model: 'mijia.watch.band01'
  },
  // 孔明
  {
    alias: ['hmpace.bracelet.v5h'],
    model: 'hmpace.bracelet.v5'
  },
  // 后羿
  {
    alias: ['midr.watch.dsi'],
    model: 'midr.watch.ds'
  },
  // 木兰
  {
    alias: [
      'mijia.watch.v1in',
      'mijia.watch.v1dist',
      'mijia.watch.v1hktw',
      'mijia.watch.v1la',
      'mijia.watch.v1ru'
    ],
    model: 'mijia.watch.v1'
  },
  // 后羿lite
  {
    alias: ['midr.watch.sportsa', 'midr.watch.sportsi'],
    model: 'midr.watch.sports'
  },
  {
    alias: ['midr.watch.k65b'],
    model: 'midr.watch.k65a'
  },
  {
    alias: ['lchz.watch.m65ai', 'lchz.watch.m65ac'],
    model: 'lchz.watch.m65a'
  },
  {
    alias: ['miwear.watch.m66nfc'],
    model: 'miwear.watch.m66'
  }
]

// model 在不同地区发行，会存在别名，将别名映射成唯一的 model
export const getModel = (model: string) => {
  model = model?.toLowerCase();
  return rules.find(item => item.alias.includes(model))?.model || model;
};
